module.exports = __webpack_public_path__ + "static/img/3.2b09257.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/sp/3.png
// module id = Og5v
// module chunks = 0